<template>
 <div id="coItemDiv" @click="onCoItemClick()">
    <!-- <span v-if="item['status'] === 1" > -->
    <span>
      <img v-if="selected" id="coItemImgBg" src="~assets/img/SdkV3/CashoutBgSelected.png">
      <img v-else id="coItemImgBg" src="~assets/img/SdkV3/CashoutBg.png">
    </span>
   <!-- <div v-else id="coItemImgBgGrey"></div> -->
   <div id="coItemContentDiv">
    <span id="coItemValue" :style="{color:selected?blackColor:whiteColor}">{{item['money']}}￥</span>
    <span v-show="item['once'] != 0" id="coItemLeftOver" :style="{color:selected?blackColor:whiteColor}">(剩余1次)</span>
   </div>
   <!-- <span v-show="item['status'] === 1" id="coItemLevel">LV{{item['level']}}</span> -->
   <span v-show="item['level'].length > 0" id="coItemLevel">LV{{item['level']}}</span>
 </div>
</template>

<script>
 export default {
  props:{
    item:null,
    selected: false,
    index: 0,
  },
   data () {
     return {
      blackColor: "black",
      whiteColor: "white",
     }
   },
   components: {

   },
   methods:{
    onCoItemClick(){
      // this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": this.item['desc']})
      this.$emit("setClickItemCallback", this.index);
      if (this.item['host'] == '1') {
        this.$store.commit('switchAlert', {"showOrHide": true, "alertMessage": "兑换条件："+this.item['desc']})
      }
    }
   }
 }
</script>

<style>
#coItemDiv{
  /* width: calc(100%)/2; */
  position: relative;
  height: 53px;
  width: 80px;
  align-items: Center; 
}
#coItemImgBg{
  float: left;
  object-fit: scale-down;
  /* width: calc(100%)/2; */
  height: 53px;
  width:100%;
  position:absolute;
  display: block;
}
#coItemImgBgGrey{
  float: left;
  object-fit: scale-down;
  /* width: calc(100%)/2; */
  position:absolute;
  display: block;
  background-color: #E1E1E1;
  border-radius: 5px;
  border: 1px solid #CBCBCB;
  height: 43px;
  width: calc(100% - 20px);
  margin-left: 20px;
  margin-top: 10px;
  position:absolute;
  display: flex;
  flex-direction: column;
  align-items: Center; 
  justify-content: center;
}
#coItemLevel{
  /* background-color: royalblue; */
  width: 40%;
  height: 20%;
  position: absolute;
  top: 10% ;
  float: left;
  /* background-color: aquamarine; */
  font-size: xx-small;
  left: 8%;
  color: white;
}
#coItemContentDiv{
  height: 43px;
  width: calc(100% - 10px);
  margin-left: 10px;
  margin-top: 10px;
  position:absolute;
  display: flex;
  flex-direction: column;
  align-items: Center; 
  justify-content: center;
  /* padding-left: 5%;
  padding-top: 8px; */
  /* background-color: aquamarine; */
}
#coItemValue{
  /* width: 100px; */
  /* height: 20px; */
  color:white;
  font-size: x-small;
  font-weight: bold;

}
#coItemLeftOver{ 
  /* width: 100px; */
  /* height: 20px; */
  color:white;
  font-size: xx-small;
  font-weight: bold;
}

 
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/rebateTypeMoney/cashout/CashoutItem.vue